import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './style.sass';

const Passo = ({ titulo, imagem, to, about }) => (
  <Link to={to} className="Passo">
    <h3 className="Passo__title">{titulo}</h3>
    <aside className="Passo__aside">
      <span className="Button Button--outline Passo__action">Ver mais</span>

      <p>{about}</p>
    </aside>

    <div className="Passo__image-container">
      <img src={imagem} alt={titulo} />
    </div>
  </Link>
);

Passo.propTypes = {
  titulo: PropTypes.string.isRequired,
  imagem: PropTypes.string.isRequired,
  to: PropTypes.string,
  about: PropTypes.string,
};

Passo.defaultProps = {
  to: '',
  about: '',
};

export default Passo;
